var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Windows, Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    d: "M14 9.166V14.122C14 14.2563 13.9729 14.3892 13.9205 14.5128C13.868 14.6364 13.7911 14.7482 13.6945 14.8415C13.5979 14.9347 13.4834 15.0076 13.3581 15.0557C13.2327 15.1037 13.0989 15.1261 12.9647 15.1213L12.876 15.114L8 14.5047V9.166H14ZM6.66667 9.166V14.338L3.168 13.9007C2.84547 13.8604 2.54877 13.7036 2.33368 13.4599C2.11859 13.2162 1.99993 12.9024 2 12.5773V9.166H6.66667ZM12.876 1.88467C13.0092 1.86802 13.1445 1.87838 13.2736 1.91513C13.4028 1.95188 13.5232 2.01427 13.6278 2.09858C13.7323 2.18288 13.8188 2.28737 13.882 2.40582C13.9453 2.52427 13.9841 2.65425 13.996 2.788L14 2.87667V7.83267H8V2.494L12.876 1.88467ZM6.66667 2.66067V7.83267H2V4.42133C1.99993 4.09629 2.11859 3.78242 2.33368 3.53873C2.54877 3.29504 2.84547 3.1383 3.168 3.098L6.66667 2.66067Z",
    fill: "#00ADEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.f297f3d894a5d4cc23f86ced38343c87.svg";
export { ForwardRef as ReactComponent };